import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BookmarkModel } from 'src/app/core/model/object/recipe-model';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-cooking-story-favorite',
  templateUrl: './cooking-story-favorite.component.html',
  styleUrls: ['./cooking-story-favorite.component.scss'],
})
export class CookingStoryFavoriteComponent implements OnInit {
  public shadowNav: boolean = false;
  bookmarks: BookmarkModel[];
  @ViewChild('scroolEl') scroolEl: ElementRef<HTMLDivElement>;
  ready: boolean = false;
  constructor(private recipeService: RecipeService) {}

  ngOnInit(): void {
    this.getBookmarks();
  }
  scrolling(data) {
    let scroolTop = this.scroolEl.nativeElement.scrollTop;

    if (scroolTop >= 90) {
      this.shadowNav = true;
    } else {
      this.shadowNav = false;
    }
  }
  public goBak() {
    this.recipeService.back();
  }
  public getBookmarks() {
    this.recipeService.getBookmarkedRecipes().then((res) => {
      this.bookmarks = res.getData().getBookmarks();
      this.ready = true;
    });
  }
  openRecipe(recipeId) {
    this.recipeService.goToRecipeDetail(recipeId);
  }
  garr(length: number) {
    return new Array(length);
  }
}
